import { Link } from 'react-router-dom';
import { useInView } from '@/hooks/useInView';

function RevealSection({ children, className = '', delay = 0 }) {
  const [ref, isInView] = useInView();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${className}`}
      style={{
        opacity: isInView ? 1 : 0,
        transform: isInView ? 'translateY(0)' : 'translateY(24px)',
        transitionDelay: `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}

export default function RefundPolicy() {
  return (
    <div data-testid="refund-policy-page" className="px-6 lg:px-8 pt-[80px] pb-[100px] md:pt-[120px] md:pb-[120px]">
      <div className="max-w-2xl mx-auto">
        <RevealSection>
          <p className="font-inter text-xs font-semibold tracking-[0.25em] uppercase text-km-gold mb-4">Legal</p>
          <h1 className="font-inter font-bold text-[38px] md:text-[54px] leading-[1.1] tracking-tight text-km-white">
            Refund Policy
          </h1>
        </RevealSection>

        <RevealSection delay={100}>
          <div className="mt-10 p-[30px] md:p-[50px] rounded-[10px] bg-km-card-gradient border border-km-gray-3 space-y-6 font-inter font-medium text-base text-km-gray-5 leading-[1.3]">
            <p>
              Because this is a digital product delivered instantly (including access to downloadable/copyable materials), <strong className="font-semibold text-km-white">all sales are final</strong>.
            </p>

            <p>
              If you experience an access issue (e.g., the link does not work, you cannot duplicate the template, or you didn't receive the delivery page), contact us within <strong className="font-semibold text-km-white">7 days</strong> of purchase and we will resolve it or provide access.
            </p>

            <p>
              If you accidentally purchased multiple times, contact us within <strong className="font-semibold text-km-white">24 hours</strong> and we will help correct it.
            </p>

            <div className="mt-8 pt-8 border-t border-km-gray-3">
              <p className="font-inter font-medium text-km-white">Contact</p>
              <a
                href="mailto:hello@kingmakersinc.ca"
                className="font-inter font-medium text-km-gold hover:text-km-gold-deep transition-colors cursor-pointer"
              >
                hello@kingmakersinc.ca
              </a>
            </div>
          </div>
        </RevealSection>

        <RevealSection delay={200}>
          <div className="mt-16 text-center">
            <Link to="/" className="font-inter font-medium text-sm text-km-gray-5 hover:text-km-white transition-colors cursor-pointer">
              &larr; Back to King Makers
            </Link>
          </div>
        </RevealSection>
      </div>
    </div>
  );
}
